import React, { useEffect } from 'react';
import { Grid } from 'semantic-ui-react';

import GeneralHelper from '../../helpers/general';
import Loading from '../../components/Loading';

const CallbackCasPage = (props) => {
	useEffect(() => {
		const query = GeneralHelper.queryStringToObject(props.location.search);
		props.authorizeWithTicket({ query });
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<Grid>
			<Grid.Row>
				<Grid.Column width={16}>
					<Loading />
				</Grid.Column>
			</Grid.Row>
		</Grid>
	);
};

export default CallbackCasPage;
